
/**
 * Reusable Analytics Table Component
 * @param {string} title - Table title
 * @param {Array} data - Table data array
 * @param {Array} columns - Column configuration array
 */
const AnalyticsTable = ({ title, data, columns }) => {
  return (
    <div className="hvnly-table-card">
      <div className="hvnly-chart-header">
        <h2 className="hvnly-chart-title">{title}</h2>
        <button className="hvnly-chart-action-btn">
          <i className="fas fa-download"></i>
          Export
        </button>
      </div>
      <table className="hvnly-table">
        <thead>
          <tr>
            {columns.map((column, index) => (
              <th key={index}>{column.header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((item, rowIndex) => (
            <tr key={rowIndex}>
              {columns.map((column, colIndex) => (
                <td key={colIndex}>
                  {column.render ? column.render(item, rowIndex) : item[column.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AnalyticsTable;